import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';
import AppConfig from '../../providers/AppConfig';

export const TOAST_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

const toasterSlice = createSlice({
  name: 'toasts',
  initialState: [],
  reducers: {
    addToast: (state, { payload }) => {
      validateToast(payload);

      const nextId = state.reduce((max, toast) => Math.max(max, toast.id), -1) + 1;
      const defaultOptions = { timeout: AppConfig.defaultToastTime, disableClick: false };
      const isDuplicate = Boolean(
        state.find((toast) => toast.body.message === payload.body.message && toast.body.type === payload.body.type)
      );

      if (isDuplicate) {
        return state;
      }

      state.push({
        id: nextId,
        body: { ...payload.body },
        options: { ...defaultOptions, ...payload.options },
      });
    },
    removeToast: (state, { payload }) => {
      return state.filter((toast) => toast.id !== payload);
    },
  },
});

function validateToast(toast) {
  if (!toast.body) {
    throw new Error('Alert has no body');
  }
  if (!toast.body.message) {
    throw new Error('Alert has empty message');
  }
  if (!toast.body.type || !Object.values(TOAST_TYPE).includes(toast.body.type)) {
    throw new Error('Wrong alert type');
  }
}

export const { addToast, removeToast } = toasterSlice.actions;
export default toasterSlice.reducer;

// --- Toast utility functions ---
// These are standalone functions, NOT dispatchable action creators.
// Call them directly: successToast('message') — NOT dispatch(successToast('message'))

let storeRef;
export const initToastUtils = (store) => {
  storeRef = store;
};

const createToastUtil =
  (type, defaultTitleKey) =>
  (payload, title = i18n.t(defaultTitleKey)) => {
    const toast =
      typeof payload === 'string' && title
        ? { body: { message: payload, title, type } }
        : { body: { message: payload.message, title: payload.title, type }, options: payload.options };

    storeRef.dispatch(addToast(toast));
  };

export const successToast = createToastUtil(TOAST_TYPE.SUCCESS, 'common:successToastHeading');
export const warningToast = createToastUtil(TOAST_TYPE.WARNING, 'common:warningToastHeading');
export const errorToast = createToastUtil(TOAST_TYPE.ERROR, 'common:errorToastHeading');
